import client from '@/api/client'
import type { components } from '@/api/typeApi'

type CreateSubnetRequest = components['schemas']['CreateSubnetRequest']
type UpdateSubnetRequest = components['schemas']['UpdateSubnetRequest']
export interface FetchNodesParams {
  clusterId?: string
  providerId?: string
  status?: 'maintenance' | 'ready' | 'deleted'
  pagination?: {
    page?: number
    per_page?: number
  }
}

export interface FetchSubnetsParams {
  clusterId?: string
  providerId?: string
  name?: string
  pagination?: {
    page?: number
    per_page?: number
  }
}

export const fetchSubnets = async () => {
  return client.GET('/v1/subnets/extended', {})
}

export const fetchSubnetsPaginated = async (
  params: FetchSubnetsParams = {},
) => {
  return client.GET('/v1/subnets', {
    params: {
      query: {
        ...(params.clusterId && { clusterId: params.clusterId }),
        ...(params.providerId && { providerId: params.providerId }),
        ...(params.name && { name: params.name }),
        ...(params.pagination && { pagination: params.pagination }),
      },
    },
  })
}

export const fetchNodes = async (params: FetchNodesParams = {}) => {
  return client.GET('/v1/nodes/extended', {
    params: {
      query: {
        ...(params.clusterId && { clusterId: params.clusterId }),
        ...(params.providerId && { providerId: params.providerId }),
        ...(params.status && { status: params.status }),
        ...(params.pagination && { pagination: params.pagination }),
      },
    },
  })
}

export const postSubnet = async (body: CreateSubnetRequest) => {
  return client.POST('/v1/subnets', {
    body,
  })
}

export const patchSubnet = async (
  subnetId: string,
  body: UpdateSubnetRequest,
) => {
  return client.PATCH('/v1/subnets/{subnet_id}', {
    params: {
      path: {
        subnet_id: subnetId,
      },
    },
    body,
  })
}

export const deleteSubnet = async (subnetId: string) => {
  return client.DELETE('/v1/subnets/{subnet_id}', {
    params: {
      path: {
        subnet_id: subnetId,
      },
    },
  })
}

export const fetchClusters = async () => {
  return client.GET('/v1/clusters')
}

export const fetchClusterById = async (clusterId: string) => {
  return client.GET('/v1/clusters/{cluster_id}', {
    params: {
      path: {
        cluster_id: clusterId,
      },
    },
  })
}

export const assignSubnetsToCluster = async (
  clusterId: string,
  subnetIds: string[],
) => {
  return client.POST('/v1/clusters/{cluster_id}/subnets', {
    params: {
      path: {
        cluster_id: clusterId,
      },
    },
    body: {
      subnets: subnetIds,
    },
  })
}
